import {Sparkles} from 'lucide-react';

export default function NotReady() {
  const mapaLink = "https://elementos.reacendaluz.com.br";

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-deep via-violet-medium to-rose-deep/40 flex items-center justify-center px-6">
      <div className="max-w-2xl w-full">
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 text-center border border-violet-dust/30">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-violet-dust/30 mb-8 animate-pulse">
            <Sparkles className="w-10 h-10 text-violet-deep" />
          </div>
          
          <h1 className="font-serif text-3xl md:text-5xl font-bold text-violet-deep mb-8">
            Um passo de cada vez.
          </h1>
          
          <p className="font-sans text-gray-700 text-base md:text-lg leading-relaxed mb-8">
            Obrigada pela honestidade. Isso mostra maturidade e autoconsciência. O momento certo para a Leitura vai chegar. Enquanto isso criei um teste gratuito que vai revelar qual elemento está bloqueando sua vida agora e mostrar onde estão as raízes dos seus ciclos.
          </p>
          
          <a
            href={mapaLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-gradient-to-r from-rose-soft via-rose-deep to-pink-500 hover:from-pink-500 hover:via-rose-deep hover:to-rose-soft text-white font-sans font-bold text-lg px-10 py-4 rounded-full transition-all duration-300 shadow-[0_0_40px_rgba(236,72,153,0.8)] hover:shadow-[0_0_60px_rgba(236,72,153,1)] transform hover:scale-105"
          >
            Fazer o teste gratuito dos 4 Elementos
          </a>
        </div>
      </div>
    </div>
  );
}
